export const TermsOfUsePage = () => {
  return (
    <>TermsOfUsePage</>
  )
}
